import React from "react"
import PropTypes from "prop-types"
import SettingCard from "./SettingCard"

const settingProps = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export function SubscriptionPackageSetting({ value, onChange }) {
  return (
    <SettingCard
      id="subscriptionPackage-enabled"
      icon="bx bx-package"
      label="Subscription Package"
      description="Let customers buy subscription packages on the website."
      enabled={!!value.enabled}
      onToggle={() => onChange({ ...value, enabled: !value.enabled })}
    />
  )
}
SubscriptionPackageSetting.propTypes = settingProps
